import { Partners } from '@lockton-apps/shared/interfaces';
import {
  AccaOverClassOfBusinessId,
  AccaOverProductConfigId,
  AccaProductConfigId,
  ConstructionClassOfBusinessId,
  ConstructionProductConfigId,
  EnwClassOfBusinessId,
  EnwProductConfigId,
  NorwayClassOfBusinessId,
  NorwayProductConfigId,
  PerformanceProductConfigId,
  RegulatoryClassOfBusinessId,
  RegulatoryProductConfigId,
} from '@lockton-apps/shared/util/constants';
import { MockedClientDefaultId } from '@lockton-apps/shared/util/mocks';

export const proposalsMocks = {
  [Partners.ACCA]: {
    [AccaProductConfigId.Default]: {
      DEFAULT: {
        selectedProducts: [AccaOverClassOfBusinessId.NationalAccountantsAcca],
        subType: AccaProductConfigId.Default,
      },
    },
  },
  [Partners.ACCA_OVER]: {
    [AccaOverProductConfigId.InsolvencyPractitioners]: {
      DEFAULT: {
        selectedProducts: [AccaOverClassOfBusinessId.NationalAccountants],
        subType: AccaOverProductConfigId.InsolvencyPractitioners,
      },
    },
    [AccaOverProductConfigId.ShortProposalForm]: {
      DEFAULT: {
        selectedProducts: [AccaOverClassOfBusinessId.NationalAccountantsAcca],
        subType: AccaOverProductConfigId.ShortProposalForm,
      },
    },
    [AccaOverProductConfigId.LongProposalForm]: {
      DEFAULT: {
        selectedProducts: [AccaOverClassOfBusinessId.NationalAccountants],
        subType: AccaOverProductConfigId.LongProposalForm,
      },
    },
    [AccaOverProductConfigId.NewStartUpAccountants]: {
      DEFAULT: {
        selectedProducts: [AccaOverClassOfBusinessId.NationalAccountants],
        subType: AccaOverProductConfigId.NewStartUpAccountants,
      },
    },
  },
  [Partners.CONSTRUCTION]: {
    [ConstructionProductConfigId.ArchitectsAndEngineers]: {
      DEFAULT: {
        selectedProducts: [ConstructionClassOfBusinessId.ProfessionsArchitects],
        subType: ConstructionProductConfigId.ArchitectsAndEngineers,
      },
    },
    [ConstructionProductConfigId.DesignAndConstruction]: {
      DEFAULT: {
        selectedProducts: [
          ConstructionClassOfBusinessId.ProfessionsDesignAndConstruction,
        ],
        subType: ConstructionProductConfigId.DesignAndConstruction,
      },
    },
    [ConstructionProductConfigId.Retail]: {
      DEFAULT: {
        selectedProducts: [ConstructionClassOfBusinessId.ProfessionsSurveyors],
        subType: ConstructionProductConfigId.Retail,
      },
    },
    [ConstructionProductConfigId.MidMarketNonTSA]: {
      DEFAULT: {
        selectedProducts: [ConstructionClassOfBusinessId.ProfessionsSurveyors],
        subType: ConstructionProductConfigId.MidMarketNonTSA,
      },
    },
    [ConstructionProductConfigId.MidMarketTSA]: {
      DEFAULT: {
        selectedProducts: [ConstructionClassOfBusinessId.ProfessionsSurveyors],
        subType: ConstructionProductConfigId.MidMarketTSA,
      },
    },
  },
  [Partners.REGULATORY]: {
    [RegulatoryProductConfigId.FinancialAdvisers]: {
      DEFAULT: {
        selectedProducts: [
          RegulatoryClassOfBusinessId.RegulatoryFinancialServices,
        ],
        subType: RegulatoryProductConfigId.FinancialAdvisers,
      },
    },
    [RegulatoryProductConfigId.Intermediaries]: {
      DEFAULT: {
        selectedProducts: [
          RegulatoryClassOfBusinessId.RegulatoryMortgageAdvisors,
        ],
        subType: RegulatoryProductConfigId.Intermediaries,
      },
    },
    [RegulatoryProductConfigId.LloydsBrokers]: {
      DEFAULT: {
        selectedProducts: [RegulatoryClassOfBusinessId.RegulatoryLloyds],
        subType: RegulatoryProductConfigId.LloydsBrokers,
      },
    },
  },
  [Partners.ENW]: {
    [EnwProductConfigId.Endurance]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.Endurance,
      },
    },
    [EnwProductConfigId.Travelers]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.Travelers,
      },
    },
    [EnwProductConfigId.HDIUnder25]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.HDIUnder25,
      },
    },
    [EnwProductConfigId.HDIOver25]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.HDIOver25,
      },
    },
    [EnwProductConfigId.Solicitors]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.Solicitors,
      },
    },
    [EnwProductConfigId.QBE]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.QBE,
      },
    },
    [EnwProductConfigId.MT]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.MT,
      },
    },
    [EnwProductConfigId.SolePractitioner]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.SolePractitioner,
      },
    },
    [EnwProductConfigId.Major]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.Major,
      },
    },
    [EnwProductConfigId.MajorShort]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.MajorShort,
      },
    },
    [EnwProductConfigId.SolicitorsHdi]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.SolicitorsHdi,
      },
    },
    [EnwProductConfigId.Solicitors2025]: {
      DEFAULT: {
        selectedProducts: [EnwClassOfBusinessId.PI],
        subType: EnwProductConfigId.Solicitors2025,
      },
    },
  },
  [Partners.PERFORMANCE]: {
    [PerformanceProductConfigId.Default]: {
      DEFAULT: {
        selectedProducts: [],
        subType: PerformanceProductConfigId.Default,
      },
    },
  },
  [Partners.NORWAY]: {
    [NorwayProductConfigId.Default]: {
      [MockedClientDefaultId.NorwayDefaultCorporateHealthBusiness]: {
        selectedProducts: [NorwayClassOfBusinessId.HealthBusiness],
      },
      [MockedClientDefaultId.NorwayDefaultCorporateHealthPrivate]: {
        selectedProducts: [NorwayClassOfBusinessId.HealthPrivate],
      },
    },
  },
};

export const proposalsMocksLatam = {};
